import apiClient from "../../axios/apiClient";

export const getRelationshipList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_RELATIONSHIPLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Relationship`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_RELATIONSHIPLIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_RELATIONSHIPLIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveRelationshipData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_RELATIONSHIP_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Relationship`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_RELATIONSHIP_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_RELATIONSHIP_REJECTED", payload: error.response });
    }
  };
  

  export const getRelationshipListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_RELATIONSHIPLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Relationship/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_RELATIONSHIPLISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_RELATIONSHIPLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateRelationshipData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_RELATIONSHIP_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Relationship/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_RELATIONSHIP_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_RELATIONSHIP_REJECTED", payload: error.response });
  }
};


export const updateRelationshipStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_RELATIONSHIP_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Relationship-Status/${id}`, // Endpoint URL with vehicle ID
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_RELATIONSHIP_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_RELATIONSHIP_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteRelationshipData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_RELATIONSHIP_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Relationship/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_RELATIONSHIP_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_RELATIONSHIP_REJECTED", payload: error.response });
  }
};